export default __webpack_public_path__ + "static/media/coming-soon.17976db6.svg";